import { truncateFilename } from 'truncateFilename'

export const truncate = (fileName: string) =>
  truncateFilename(fileName, 100, '...')
